import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { IModuloInterface, useUserInfor } from "../../../../../Context/User";
import SpinnerComponent from "../../../../Loding/Spinner";
import { IComponentModal } from "../../../../Modais/IModalComponent";
import { ModulosLG } from "../../../../Modulos";

import "./styles.css";

interface ISeletorDeModuloProps {
    setShow: (show: boolean) => void;
    then: (modulo: IModuloInterface) => void;
}

export default function SeletorDeModulo(props: ISeletorDeModuloProps) {
    const { MODULOS } = useUserInfor().OrgInfor;

    return (
        <>
            {MODULOS ? (
                <div className="d-flex flex-wrap align-items-center justify-content-center">
                    {MODULOS.filter((mod) => mod.ID_MODULO !== 8 && mod.ID_MODULO !== 11).map(
                        (modulo) => (
                            <span
                                key={modulo.ID_MODULO}
                                className="m-2"
                                onClick={() => {
                                    props.setShow(false);
                                    props.then(modulo);
                                }}
                            >
                                <ModulosLG Modulo={modulo} />
                            </span>
                        )
                    )}
                </div>
            ) : (
                <SpinnerComponent />
            )}
        </>
    );
}

export function SelecionarTipoCaso(
    setShow: (show: boolean) => void,
    setModal: (modal: IComponentModal) => void,
    callbackModulo: (ID_TIPO_CASO: IModuloInterface) => void
) {
    setModal({
        noHeader: true,
        noFooter: true,
        IconHeader: faAngleRight,
        Component: () => (
            <SeletorDeModulo
                setShow={setShow}
                then={(modulo) => {
                    setTimeout(() => {
                        callbackModulo(modulo);
                    }, 300);
                }}
            />
        ),
    });
    setShow(true);
}
